module.exports = {"430502001":"兴隆街道","430502002":"龙须塘街道","430502003":"汽车站街道","430502004":"小江湖街道","430502005":"东风路街道","430502006":"桥头街道","430502007":"滨江街道","430502008":"石桥街道","430502009":"爱莲街道","430502100":"高崇山镇","430502101":"渡头桥镇","430502202":"火车站乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430502.json
// module id = 1687
// module chunks = 0